import { Fragment } from 'react';
import { cn } from '@/lib/utils';
import LinkButton from '@/components/atoms/linkButton';
import { WithRef } from '@/components/types';

export interface BreadcrumbsProps extends React.HTMLAttributes<HTMLDivElement> {
  classNames?: {
    root: string;
  };
  items: {
    label: React.ReactNode;
    href: string;
  }[];
}

const commonStyles = 'text-body-s text-neutral-N99';

const Breadcrumbs = ({
  items,
  classNames,
  ref,
  ...props
}: WithRef<HTMLDivElement, BreadcrumbsProps>) => {
  function isLastItem(index: number) {
    return items.length - 1 === index;
  }

  return (
    <div
      data-tracker-component='breadcrumb'
      className={cn('flex flex-wrap items-center gap-2', classNames?.root)}
      ref={ref}
      itemScope
      itemType='https://schema.org/BreadcrumbList'
      {...props}
    >
      {items.map((item, index) => (
        <Fragment key={index}>
          {isLastItem(index) ? (
            <span
              className='text-body-s text-neutral-dark-N50'
              itemProp='itemListElement'
              itemScope
              itemType='https://schema.org/ListItem'
            >
              <span itemProp='name'>{item.label}</span>
              <meta itemProp='position' content={String(index + 1)} />
            </span>
          ) : (
            <>
              <span
                itemProp='itemListElement'
                itemScope
                itemType='https://schema.org/ListItem'
              >
                <LinkButton
                  href={item.href}
                  classNames={{
                    root: commonStyles,
                  }}
                  variant='text'
                  slim
                  itemProp='item'
                >
                  <span itemProp='name'>{item.label}</span>
                </LinkButton>
                <meta itemProp='position' content={String(index + 1)} />
              </span>
              <span className={cn(commonStyles)}>{'>'}</span>
            </>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
